import { Route, Routes } from "react-router-dom";
import { ClientsLogo } from "./components/ClientsLogo";
import CompanyOverview from "./components/CompanyOverview";
import Footer from "./components/Footer";
import { Header } from "./components/Header";
import HeroSection from "./components/HeroSection";
import HighlightStats from "./components/HighlightStats";
import OurMethodology from "./components/OurMethodology";
import ServicesComponent from "./components/ServicesSection";
import { EmployeeTransportation } from "./components/ services/EmployeeTransportation";
import CorporateCar from "./components/ services/CorporateCar";
import AirportTransfer from "./components/ services/AirportTransfer";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/contact-us/ContactUs";
import ScrollToTop from "./components/ScrollToTop";
import QuotationForm from "./components/ get-a-quote/QuotationForm";

function App() {
  return (
    <div>
      <main className="max-w-7xl px-6 md:px-10 mx-auto">
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={
            <>
              <HeroSection />
              <ClientsLogo />
              <CompanyOverview />
              <HighlightStats />
              <ServicesComponent />
              <OurMethodology />
            </>
          } />  
          <Route path="/employee-transportation" element={<EmployeeTransportation/>}/>
          <Route path="/itemployeetransportationpvr.html" element={<EmployeeTransportation/>}/>
          <Route path="/corporate-car" element={<CorporateCar/>}/>
          <Route path="/corporatecar.html" element={<CorporateCar/>}/>
          <Route path="/airport-transfer" element={<AirportTransfer/>}/>
          <Route path="/airport-transfer.html" element={<AirportTransfer/>}/>
          <Route path="/about" element={<AboutUs/>}/>
          <Route path="/quote" element={<QuotationForm/>}/>
          <Route path="/quotation.html" element={<QuotationForm/>}/>
          <Route path="/contact" element={<ContactUs/>}/>
        </Routes>
        <div className="pb-10" />
      </main>
      <Footer />
    </div>
  );
}

export default App;
